module.exports = __webpack_public_path__ + "img/method-title.7dbaf862.png";